(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioDeleteController',SSAnioDeleteController);

    SSAnioDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSAnio'];

    function SSAnioDeleteController($uibModalInstance, entity, SSAnio) {
        var vm = this;

        vm.sSAnio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAnio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
